// @ts-nocheck
import { useEffect } from "react";
import { formatCurrencyBRL, toNumber } from "../../../../../utils";
import "./TabelaValores.css";

const pegarParcelas = (TabelaReembolso) => {
  if (!TabelaReembolso) return [];
  if (Array.isArray(TabelaReembolso)) return TabelaReembolso;
  if (Array.isArray(TabelaReembolso.parcelas)) return TabelaReembolso.parcelas;
  if (Array.isArray(TabelaReembolso.Parcelas)) return TabelaReembolso.Parcelas;
  return [];
};

const pegarDespesas = (DadosDespesas) => {
  if (!DadosDespesas) return [];
  if (Array.isArray(DadosDespesas)) return DadosDespesas;
  if (Array.isArray(DadosDespesas.despesas)) return DadosDespesas.despesas;
  if (Array.isArray(DadosDespesas.Despesas)) return DadosDespesas.Despesas;
  return [];
};

const ordinalParcela = (n) => (n === 1 ? "1ª" : n === 2 ? "2ª" : `${n}ª`);
const sit = (s) =>
  String(s || "")
    .trim()
    .toLowerCase();

const isSelecionada = (p) => {
  const s = sit(p?.situacao);
  if (s === "já solicitado" || s === "solicitado") return false;
  if (s === "solicitando") return true;
  return p?.solicitar === true;
};

const isDespesaConforme = (d) =>
  d?.conforme === true ||
  String(d?.status || "")
    .trim()
    .toUpperCase() === "CONFORME";

const TabelaValores = ({
  TabelaReembolso,
  DadosDespesas,
  liberarParcela = false,
  onTotalsChange,
  usarTodasParcelas = false,
}) => {
  const parcelas = pegarParcelas(TabelaReembolso);

  const selecionadas = usarTodasParcelas
    ? parcelas
    : parcelas.filter(isSelecionada);

  const tiposOrdenados = [
    ...new Set(selecionadas.map((p) => Number(p?.idTipoParcela))),
  ]
    .filter(Number.isFinite)
    .sort((a, b) => a - b);

  const valorLiquidoSolicitacao = selecionadas.reduce(
    (acc, p) => acc + toNumber(p?.valor),
    0,
  );

  const despesas = pegarDespesas(DadosDespesas);
  const totalDespesas = despesas
    .filter((d) => d?.deletar !== true && isDespesaConforme(d))
    .reduce((acc, d) => acc + toNumber(d?.valor ?? d?.valorComprovado), 0);

  const valorSemComprovacao = Math.max(
    0,
    valorLiquidoSolicitacao - totalDespesas,
  );

  const totalQueSeraApoiado = liberarParcela
    ? valorLiquidoSolicitacao
    : Math.min(totalDespesas, valorLiquidoSolicitacao);

  useEffect(() => {
    onTotalsChange?.({
      somaParcelasSelecionadas: valorLiquidoSolicitacao,
      totalDespesas,
      valorSemComprovacao,
      totalQueSeraApoiado,
    });
  }, [
    valorLiquidoSolicitacao,
    totalDespesas,
    valorSemComprovacao,
    totalQueSeraApoiado,
    onTotalsChange,
  ]);

  const labelDoTipo = (tipo) => {
    const row = selecionadas.find((p) => Number(p?.idTipoParcela) === tipo);
    return (
      (row?.descricao && row.descricao.toUpperCase()) ||
      `${ordinalParcela(tipo)} PARCELA`
    );
  };

  return (
    <div className="card shadow-sm p-4 mb-4">
      <h5 className="fw-bold text-uppercase mb-4">Valores</h5>

      <div className="table-responsive">
        <table className="table tabela-valores mb-0">
          <tbody>
            {tiposOrdenados.map((tipo) => {
              const totalTipo = selecionadas
                .filter((p) => Number(p?.idTipoParcela) === tipo)
                .reduce((sum, p) => sum + toNumber(p?.valor), 0);
              if (totalTipo <= 0) return null;
              return (
                <tr key={`parcela-${tipo}`}>
                  <td>{labelDoTipo(tipo)}</td>
                  <td>{formatCurrencyBRL(totalTipo)}</td>
                </tr>
              );
            })}

            <tr>
              <td>VALOR TOTAL DAS DESPESAS COMPROVADAS</td>
              <td>{formatCurrencyBRL(totalDespesas)}</td>
            </tr>
            <tr>
              <td>TOTAL QUE SERÁ APOIADO</td>
              <td>{formatCurrencyBRL(totalQueSeraApoiado)}</td>
            </tr>
            <tr>
              <td>VALOR SEM COMPROVAÇÃO</td>
              <td>{formatCurrencyBRL(valorSemComprovacao)}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default TabelaValores;
